import { message } from 'antd';
import { AxiosInstance } from 'axios';

import { ENTITY_TYPE, MessageChat } from '@/model/General/MessageChat';
import User from '@/model/General/User';

import MessageChatApi from './MessageChatApi';

class MessageChatRepository {
  messageChatApi: MessageChatApi;

  constructor(axiosInstance: AxiosInstance) {
    this.messageChatApi = new MessageChatApi(axiosInstance);
  }

  getMessages = async (entityType: ENTITY_TYPE, entityId: number) => {
    try {
      const messages: MessageChat[] = await this.messageChatApi.getMessages(entityType, entityId);

      return messages.map(msg => ({
        ...msg,
        origin_user_data: msg.origin_user_data ? new User(msg.origin_user_data) : msg.origin_user_data,
      }));
    } catch (error) {
      message.error('Error al obtener los mensajes');
      throw error;
    }
  };

  postMessage = async (messageChat: MessageChat) => {
    try {
      const response = await this.messageChatApi.postMessage(messageChat);

      return response.data;
    } catch (error) {
      message.error('Error al enviar el mensaje');
      throw error;
    }
  };
}

export default MessageChatRepository;
